import ExportLayersWidget from "./ExportLayersWidget";

//section to download csv
const downloadCSV = (csv, filename) => {
  var CSV = "\ufeff" + csv;
  var csvFile;
  var downloadLink;
  var done = false;
  csvFile = new Blob([CSV], { type: 'type: "text/csv;charset=UTF-8"' });
  downloadLink = document.createElement("a");
  downloadLink.download = filename;

  downloadLink.href = window.URL.createObjectURL(csvFile);
  downloadLink.style.display = "none";
  document.body.appendChild(downloadLink);
  downloadLink.click();
  downloadLink.remove();
  done = true;

  return done;
  
};

const exportTableToCSV = (layerName,fields,features,) => {
  var csv = [];
  var headerRow = [];
  let fieldObject={}
  var done = false;
  for (var a = 0; a < fields.length; a++) {
    headerRow.push(fields[a].label);
    fieldObject[fields[a].name]={name:fields[a].name,type:fields[a].type}
  }
   csv.push(headerRow.join("|"));

   for (let i = 0; i<features.length;i++){
    let attributes=[]
    for(let key in features[i].attributes){
      if(fieldObject.hasOwnProperty(key)){
        if(fieldObject[key].type!=='date'){
          attributes.push(features[i].attributes[key])
        }
        else{
          if(null!== features[i].attributes[key]){
          attributes.push(new Date(features[i].attributes[key]).toDateString())
          }
          else{
            attributes.push('')
          }
        }

      }
        
    }
    csv.push(attributes.join("|"))
   }
  done = downloadCSV(csv.join("\n"), `${layerName}.csv`);

  return done;
};
export default exportTableToCSV;
